import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { PageNotFoundComponent } from "src/app/layout/pages/page-not-found/page-not-found.component";
import { BatchExportSmartComponent } from "./batch-export/batch-export-smart.component";
import { ConsumerAcquisitionSmartComponent } from "./consumer-acquisition/consumer-acquisition-smart.component";
import { InvoicesSmartComponent } from "./invoices/invoices-smart.component";
import { PaymentReportSmartComponent } from "./payment-report/payment-report-smart.component";
import { RealTimeTransactionsSmartComponent } from "./real-time-transactions/real-time-transactions-smart.component";
import { TransactionSummarySmartComponent } from "./transaction-summary/transaction-summary-smart.component";
import { TransactionHistoryComponent } from "./transaction-history/transaction-history.component";
import { ConsumerGuard } from "src/app/framework/crosscutting/authorization/consumer.guard";

export const consumerReportsRoutes: Routes = [
  {
    path: "invoices",
    component: InvoicesSmartComponent,
  },
  {
    path: "payment-report",
    component: PaymentReportSmartComponent,
  },
  {
    path: "batch-export",
    component: BatchExportSmartComponent,
  },
  // {
  //   path: 'batch-export/create-batch', component: CreateBatchComponent
  // },
  {
    path: "real-time-transactions",
    component: RealTimeTransactionsSmartComponent,
    canActivate: [ConsumerGuard],
  },
  {
    path: "transaction-summary",
    component: TransactionSummarySmartComponent,
  },
  {
    path: "transaction-history",
    component: TransactionHistoryComponent,
  },
  {
    path: "consumer-acquisition",
    component: ConsumerAcquisitionSmartComponent,
  },
  {
    path: "",
    component: RealTimeTransactionsSmartComponent,
  },
  {
    path: "**",
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(consumerReportsRoutes)],
  exports: [RouterModule],
})
export class ConsumerReportRoutingModule {}
